import { Paper, Theme } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  skeleton: {
    backgroundColor: theme.palette.mode === 'dark' ? 'grey' : 'lightgrey',
    height: '6em',
    margin: 10,
  },
}));

export const GenericSkeleton = () => {
  const classes = useStyles();
  return (
    <Paper style={{ padding: 8 }} elevation={0}>
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={500}
      />
    </Paper>
  );
};
